import React from 'react';
import { Box, FormControl, InputLabel, Select, MenuItem, Typography } from '@mui/material';

const Controls = ({
  timezone,
  onTimezoneChange,
  dateRange,
  onDateRangeChange,
  timezones,
  refreshInterval,
  onRefreshIntervalChange,
  layout = 'top',
}) => {
  const selectSx = {
    '& .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(17, 47, 38, 0.2)' },
    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(17, 47, 38, 0.5)' },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: 'var(--color-brand)',
      borderWidth: '2px',
    },
    backgroundColor: 'rgba(255, 255, 255, 0.88)',
  };

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: '1fr',
        gap: 1.1,
        borderRadius: '18px',
        border: '1px solid var(--ops-border)',
        background:
          'linear-gradient(130deg, rgba(236, 246, 243, 0.95), rgba(255, 255, 255, 0.95) 46%, rgba(255, 246, 240, 0.82))',
        p: 1.1,
        boxShadow: '0 14px 30px rgba(13, 40, 34, 0.1)',
      }}
    >
      <Box sx={{ px: 0.2, pt: 0.1 }}>
        <Typography
          variant="overline"
          sx={{ letterSpacing: 1.2, color: 'rgba(11, 79, 74, 0.78)', fontWeight: 800 }}
        >
          Settings
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns:
            layout === 'rail'
              ? '1fr'
              : { xs: '1fr', sm: 'repeat(2, minmax(180px, 1fr))', lg: 'repeat(3, minmax(170px, 1fr))' },
          gap: 1,
        }}
      >
        <FormControl sx={{ minWidth: 150, width: '100%' }}>
          <InputLabel sx={{ '&.Mui-focused': { color: 'var(--color-brand)' } }}>Timezone</InputLabel>
          <Select value={timezone} label="Timezone" onChange={onTimezoneChange} sx={selectSx}>
            {timezones.map((tz) => (
              <MenuItem key={tz.value} value={tz.value}>
                {tz.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl sx={{ minWidth: 200, width: '100%' }}>
          <InputLabel sx={{ '&.Mui-focused': { color: 'var(--color-brand)' } }}>Time Range</InputLabel>
          <Select value={dateRange} label="Time Range" onChange={onDateRangeChange} sx={selectSx}>
            <MenuItem value="last4h">Last 4 Hours</MenuItem>
            <MenuItem value="last12h">Last 12 Hours</MenuItem>
            <MenuItem value="last24h">Last 24 Hours</MenuItem>
            <MenuItem value="last3d">Last 3 Days</MenuItem>
            <MenuItem value="last7d">Last 7 Days</MenuItem>
          </Select>
        </FormControl>

        <FormControl sx={{ minWidth: 150, width: '100%' }}>
          <InputLabel sx={{ '&.Mui-focused': { color: 'var(--color-brand)' } }}>Refresh Data</InputLabel>
          <Select value={refreshInterval} label="Refresh Data" onChange={onRefreshIntervalChange} sx={selectSx}>
            <MenuItem value={5}>5 min</MenuItem>
            <MenuItem value={15}>15 min</MenuItem>
            <MenuItem value={60}>1 hour</MenuItem>
            <MenuItem value={0}>Never</MenuItem>
          </Select>
        </FormControl>
      </Box>
    </Box>
  );
};

export default Controls;
